/**
 * Tracking tab wrapper — see LanderTrackingFormFields.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { LanderTrackingFormFields } from '../sections';
import type { VoluumLanderFormValues } from '../map-voluum-lander-form';

export interface LanderTrackingTabProps {
  values: VoluumLanderFormValues;
  patch: (p: Partial<VoluumLanderFormValues>) => void;
  disabled?: boolean;
}

const LanderTrackingTab: FC<LanderTrackingTabProps> = (props) => (
  <LanderTrackingFormFields {...props} />
);

export default LanderTrackingTab;
